import { useContext } from 'react';
import { AppContext } from '../AppContext';

export const useGenerateTasksForOrder = () => {
  const { user } = useContext(AppContext);

  // Update the function so it expects both orderNumber and deliveryDate.
  const generateTaskForOrderDelivery = ({ orderId, orderNumber, deliveryDate }) => {
    const userId = user?.uid;
    // Make sure we have a user and a delivery date.
    if (!userId || !deliveryDate) return null;
    return {
      type: 'delivery',
      orderId,       // This links the task to the order.
      orderNumber,   // Record the order number for reference.
      // Use the provided deliveryDate as the task date.
      date: new Date(deliveryDate).toISOString(),
      // Label uses the order number rather than the date.
      label: `Order #${orderNumber}`,
      done: false,
      userId,
    };
  };

  return generateTaskForOrderDelivery;
};
